export const DISCORD_INVITE_URL = "https://discord.com/invite/cqdY6SpfVR";
export const FREE_IN_BETA = true;
export const PACKAGE_JSON_FILENAME = "package.json";
export const SPEC_FILE_NAME = "SPEC.md";
